module.exports = __webpack_public_path__ + "media/images/home-page/1-2-0c6d37fb05c6691f92b684f614853fad.png";